import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import {
    Popup,
    Checkbox,
    Dropdown,
    Icon,
    Input,
} from 'semantic-ui-react';
import { get } from 'lodash';

const GlobalTableStyle = createGlobalStyle`
    font-family: Lato, sans-serif;
    color: #656158;
    td {
      .quick-filter-button {
        opacity: 0;
      }
      :hover .quick-filter-button {
        opacity: 1;
      }
      .quick-filter-button.focus {
        opacity: 1;
      }
    }
`;

const ActionsCell = styled.div`
    text-align: center;
    display: flex;
    justify-content: space-evenly;
`;

const StyledInput = styled(Input)`
    font-size: 14px;
    width: ${props => props.width || 'initial'};
    max-width: ${props => props.maxwidth || 'initial'};
    min-width: ${props => props.minwidth || 'initial'};
    &&&&& * {
        font-size: 14px;
    }
`;

const StyledDropdown = styled(Dropdown)`
    font-size: 12px;

    &&& * {
        font-size: 12px;
    }
`;

const StyledIcon = styled(Icon)`
    font-size: 14px;
`;

const DataPill = styled.div`
    margin-top: 5px;
    margin-right: 10px;
    background-color: #fff;
    border: 1px solid #e6e6e6;
    height: 30px;
    display: inline-block;
    box-sizing: border-box;
    font-size: 13px;
    border-radius: 15px;
`;
const Underline = styled.span`
    color: rgb(0,125,196);
    text-decoration: underline;
`;
const DataPillClose = styled.div`
    width: 30px;
    margin-left: 5px;
    padding-left: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
`;
const DataPillInner = styled.div`
    padding: 10px;
    display: flex;
    align-items: center;
    height: 100%;
`;
const CenterValue = styled.div`
    margin-left: 5px;
    margin-right: 5px;
`;
// add margin-top: -5px if you do not want a pill margin
const PillContainer = styled.div`
    margin-top: 15px;
    margin-bottom: 20px;
`;

const CheckboxWithTooltip = (props) => {
    // Removing tooltipGenerator function from props being passed to Checkbox
    const { tooltipGenerator, ...passThroughProps } = props;
    let content = passThroughProps.title;
    if (tooltipGenerator) {
        content = tooltipGenerator(passThroughProps.checked);
    }

    return (
        <Popup
            content={content}
            position='right center'
            mouseEnterDelay={500}
            trigger={
                <Checkbox
                    {...passThroughProps}
                    // NOTE: Tried to use styled-components but that appears to break a class in
                    // the CheckBox and the Popup cannot attach to the element
                    style={{
                        margin: '0px',
                        padding: '0px',
                        height: '17px',
                        width: '17px',
                        fontSize: '14px'
                    }}
                />
            }
        />
    );
};

const DataPills = ({ filtersApplied, removeFilter }) => {
    const removableFilters = filtersApplied.filter(filter => !filter.value.hideControl);

    if (get(removableFilters, 'length', 0) > 0) {
        return (
            <PillContainer>
                {removableFilters.map((x, index) => <DataPill key={index}>
                    <DataPillInner>
                        <Underline>{x.value.column}</Underline>
                        <CenterValue>{x.value.filter}</CenterValue>
                        <Underline>{`${x.value.value}`}</Underline>
                        <DataPillClose>
                            <Icon onClick={() => removeFilter(x)} color="red" name="window close outline"/>
                        </DataPillClose>
                    </DataPillInner>
                </DataPill>)}
            </PillContainer>
        );
    }

    return null;
};


export {
    GlobalTableStyle,
    ActionsCell,
    StyledDropdown,
    StyledInput,
    StyledIcon,
    CheckboxWithTooltip,
    DataPills,
};



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/CommonAssets.js